import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import(/* webpackChunkName: "login.chunk" */ '../views/login/Index')
        },
        {
            path: '/logout',
            redirect: {
                name: "Login"
            }
        },
        {
            path: '/unauthorized',
            name: 'unauthorized',
            component: () => import(/* webpackChunkName: "about" */ '../views/info/Unauthorized')
        },
        {
            path: '/invalidPage',
            name: 'invalidPage',
            component: () => import(/* webpackChunkName: "about" */ '../views/info/InvalidSession')
        },
        {
            path: '/dashboard',
            component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Index'),
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/UserList'),
                    props: { userType: 'SME' }
                },
                {
                    name: 'MIKRO',
                    path: '/mikro',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/UserList'),
                    props: { userType: 'MIKRO' }

                },
                {
                    name: 'SME',
                    path: '/sme',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/UserList'),
                    props: { userType: 'SME' }
                },
                {
                    name: 'ExportHistory',
                    path: '/export',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/ExportHistory')
                },
                {
                    name: 'Learning Resources',
                    path: '/learningResources',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/LearningResources')
                }
            ]

        }
    ]
})
